/* eslint-disable */
import React, { useContext, useEffect, Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Nav, Navbar, Row, Col } from 'react-bootstrap';
import { navbarBreakPoint, topNavbarBreakpoint } from 'config';
import AppContext from 'context/Context';
import Flex from 'components/common/Flex';
import Logo from 'components/common/Logo';
import NavbarVerticalMenu from './NavbarVerticalMenu';
import ToggleButton from './ToggleButton';
import { allRoutes } from 'routes/siteMaps';
import { capitalize } from 'helpers/utils';
import NavbarTopDropDownMenus from 'components/navbar/top/NavbarTopDropDownMenus';
import PurchaseCard from './PurchaseCard';
import bgNavbar from 'assets/img/generic/bg-navbar.png';
import LogoNavbar from 'components/common/LogoNavbar';
import NavbarVerticalMenu2 from './NavbarVerticalMenu2';
import IconButton from 'components/common/IconButton';
import { useNavigate } from 'react-router-dom';
import { getTicketStatusCount } from 'functions/ticket';
import { decodeToken } from 'functions/userAuth';
import SideNavbarLoading from 'components/itemsLoading/SideNavbarLoading';

const NavbarVertical = () => {
  const navigate = useNavigate();

  const [noOfTicketsMenus, setNoOfTicketsMenus] = useState([]);
  const statusMenuIconList = [
    { statusId: 5, icon: 'star' },
    { statusId: 6, icon: 'minus' },
    { statusId: 2, icon: 'spinner' },
    { statusId: 1, icon: 'ticket-alt' },
    { statusId: 3, icon: 'check-circle' },
    // { statusId: -100, icon: 'clock' }
  ];

  const [userRole,setUserRole]=useState(null);
  const [isLoadingSidebar,setIsLoadingSidebar]=useState(false);

  const loadNoofStatus = () => {
    setIsLoadingSidebar(true);
    const token = localStorage.getItem('token');
    getTicketStatusCount(token).then(data => {
      const noOfTicketMenus = [];

      data.map(d => {

        const icon = statusMenuIconList.filter(
          i => i.statusId === d.statusId
        )[0].icon;
  
        noOfTicketMenus.push({
          name: d.statusName,
          icon: icon,
          to: `/support-desk/table-view/${d.statusId}/0`,
          badge: { text: d.count }
        });
      });

      setNoOfTicketsMenus(noOfTicketMenus);
      setIsLoadingSidebar(false);
      //   const newTickets= data.filter(t=>t.statusId===1);
      //   setNoOfNewTicket(newTickets[0].count);

      //  const inProgressTickets= data.filter(t=>t.statusId===2);
      //  setNoOfInProgress(inProgressTickets[0].count);

      //  const closedTickets= data.filter(t=>t.statusId===3);
      //  setNoOfClosed(closedTickets[0].count);

      //  const activeTickets= data.filter(t=>t.statusId===5);
      //  setNoOfActiveTicket(activeTickets[0].count);

      //  const unAssignedTickets= data.filter(t=>t.statusId===6);
      //  setNoOfUnassignedTicket(unAssignedTickets[0].count);
    });
  };

  const token = localStorage.getItem('token');
  useEffect(() => {
    console.log('token', token);

    if (!token) return;

    const payload = decodeToken(token); 
    const roleId = payload.roleId;
   setUserRole(roleId);
  }, [token]);




  useEffect(() => {
    loadNoofStatus();
  }, []);

  const {
    config: {
      navbarPosition,
      navbarStyle,
      isNavbarVerticalCollapsed,
      showBurgerMenu
    }
  } = useContext(AppContext);

  const HTMLClassList = document.getElementsByTagName('html')[0].classList;

  useEffect(() => {
    if (isNavbarVerticalCollapsed) {
      HTMLClassList.add('navbar-vertical-collapsed');
    } else {
      HTMLClassList.remove('navbar-vertical-collapsed');
    }
    return () => {
      HTMLClassList.remove('navbar-vertical-collapsed-hover');
    };
  }, [isNavbarVerticalCollapsed, HTMLClassList]);

  //Control mouseEnter event
  let time = null;
  const handleMouseEnter = () => {
    if (isNavbarVerticalCollapsed) {
      time = setTimeout(() => {
        HTMLClassList.add('navbar-vertical-collapsed-hover');
      }, 100);
    }
  };
  const handleMouseLeave = () => {
    clearTimeout(time);
    HTMLClassList.remove('navbar-vertical-collapsed-hover');
  };

  const NavbarLabel = ({ label }) => (
    <Nav.Item as="li">
      <Row className="mt-3 mb-2 navbar-vertical-label-wrapper">
        <Col xs="auto" className="navbar-vertical-label navbar-vertical-label">
          {label}
        </Col>
        <Col className="ps-0">
          <hr className="mb-0 navbar-vertical-divider"></hr>
        </Col>
      </Row>
    </Nav.Item>
  );

  // Provide the refresh function via context
  return (
    <Navbar
      expand={navbarBreakPoint}
      className={classNames('navbar-vertical', {
        [`navbar-${navbarStyle}`]: navbarStyle !== 'transparent'
      })}
      variant="light"
    >
      <Flex alignItems="center">
        <ToggleButton />
        <LogoNavbar at="navbar-vertical" width={30} />
      </Flex>
      <Navbar.Collapse
        in={showBurgerMenu}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={{
          backgroundImage:
            navbarStyle === 'vibrant'
              ? `linear-gradient(-45deg, rgba(0, 160, 255, 0.86), #0048a2),url(${bgNavbar})`
              : 'none'
        }}
      >
        <div className="navbar-vertical-content scrollbar">
          <Nav className="flex-column" as="ul">
            <Fragment key={'categories'}>
              {/* <NavbarLabel label="Tickets" /> */}
              <IconButton
                className="rounded-pill me-1 mb-1"
                onClick={() => {
                  navigate('/support-desk/new-ticket');
                }}
                variant="success"
                icon="plus"
                transform="shrink-3"
              >
                New Ticket
              </IconButton>
              <br />

              {isLoadingSidebar ? <SideNavbarLoading /> : noOfTicketsMenus.map((menu,index) => (
                <NavbarVerticalMenu2
                key={index} 
                  routes={[
                    {
                      name: menu.name,
                      icon: menu.icon,
                      to: menu.to,
                      badge: menu.badge
                    }
                  ]}
                />
              ))}

            
              <NavbarVerticalMenu2
                routes={[
                  {
                    name: 'Recent Updated',
                    icon: 'clock',
                    to: `/support-desk/table-view/0/1`,
                    // badge: { text: 100 }
                  }
                ]}
              />
               {/*  <NavbarVerticalMenu2
                routes={[
                  {
                    name: 'Unassigned',
                    icon: 'minus',
                    to: `/support-desk/table-view/${6}`,
                    badge: { text: noOfUnassignedTicket }
                  }
                ]}
              />
            
              <NavbarVerticalMenu2
                routes={[
                  {
                    name: 'In Progress',
                    icon: 'spinner',
                    to: `/support-desk/table-view/${2}`,
                    badge: { text: noOfInProgress }
                  }
                ]}
              />
              <NavbarVerticalMenu2
                routes={[
                  {
                    name: 'New',
                    icon: 'ticket-alt',
                    to: `/support-desk/table-view/${1}`,
                    badge: { text: noOfNewTicket }
                  }
                ]}
              />
              <NavbarVerticalMenu2
                routes={[
                  {
                    name: 'Closed',
                    icon: 'check-circle',
                    to: `/support-desk/table-view/${3}`,
                    badge: { text: noOfClosed }
                  }
                ]}
              /> */}

              {/* <CollapseItems route={route} key={route.name} /> */}
            </Fragment>

            {allRoutes().map(route => (
              <Fragment key={route.label}>
                {!route.labelDisable && (
                  <NavbarLabel label={capitalize(route.label)} />
                )}
                <NavbarVerticalMenu routes={route.children} />
              </Fragment>
            ))}

{userRole!==2 && <>
            <hr />
            <Fragment>
              <NavbarVerticalMenu2
                routes={[
                  {
                    name: 'Dashboard',
                    icon: 'chart-pie',
                    to: '/'
                    // badge: { text: 100 }
                  }
                ]}
              />
              
              
              {/* <hr />
              <NavbarVerticalMenu2
                routes={[
                  {
                    name: 'Trash',
                    icon: 'trash-alt',
                    //to: '/support-desk/table-view',
                    //badge: { text: 100 }
                  }
                ]}
              /> */}
            </Fragment>
            </>}

          </Nav>

          <>
            {navbarPosition === 'combo' && (
              <div className={`d-${topNavbarBreakpoint}-none`}>
                <div className="navbar-vertical-divider">
                  <hr className="navbar-vertical-hr my-2" />
                </div>
                <Nav navbar>
                  <NavbarTopDropDownMenus />
                </Nav>
              </div>
            )}
            {/* <PurchaseCard /> */}
          </>
        </div>
      </Navbar.Collapse>
    </Navbar>
  );
};

NavbarVertical.propTypes = {
  label: PropTypes.string
};

export default NavbarVertical;
/* eslint-disable */
